export function capitalizeFirstLetter (word) {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export function toId (text) {
  return text.toLowerCase().replace(' ', '_')
}

export function capitalize (string) {
  return string.split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ')
}

export const nameSort = (a, b) => {
  if (a.name < b.name) return -1
  if (a.name > b.name) return 1
  return 0
}

/**
 * @param {object} a - first element to compare
 * @param {object} b - second element to compare
 * @param {string} prop - property name to sort
 * @param {number} order - -1 asc / 1 desc
 */

export const propertySort = (a, b, prop, order) => {
  const x = a[prop].toLowerCase()
  const y = b[prop].toLowerCase()
  if (x < y) return order
  if (x > y) return -order
  return 0
}
